/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AgentMessageRefusalAgent from './AgentMessageRefusalAgent';

/**
 * The AgentMessageRefusal model module.
 * @module model/AgentMessageRefusal
 * @version 1.0.0
 */
class AgentMessageRefusal {
    /**
     * Constructs a new <code>AgentMessageRefusal</code>.
     * ユーザーがお断りしたプランナー（user × agent で 1 件、解除不可）
     * @alias module:model/AgentMessageRefusal
     */
    constructor() { 
        
        AgentMessageRefusal.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AgentMessageRefusal</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentMessageRefusal} obj Optional instance to populate.
     * @return {module:model/AgentMessageRefusal} The populated <code>AgentMessageRefusal</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentMessageRefusal();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('agent_id')) {
                obj['agent_id'] = ApiClient.convertToType(data['agent_id'], 'Number');
            }
            if (data.hasOwnProperty('investment_proposal_id')) {
                obj['investment_proposal_id'] = ApiClient.convertToType(data['investment_proposal_id'], 'Number');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('agent')) {
                obj['agent'] = AgentMessageRefusalAgent.constructFromObject(data['agent']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentMessageRefusal</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentMessageRefusal</code>.
     */
    static validateJSON(data) {
        // validate the optional field `agent`
        if (data['agent']) { // data not null
          AgentMessageRefusalAgent.validateJSON(data['agent']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
AgentMessageRefusal.prototype['id'] = undefined;

/**
 * @member {Number} agent_id
 */
AgentMessageRefusal.prototype['agent_id'] = undefined;

/**
 * お断り操作をしたメッセージの投資提案 ID
 * @member {Number} investment_proposal_id
 */
AgentMessageRefusal.prototype['investment_proposal_id'] = undefined;

/**
 * お断りした日時
 * @member {Date} created_at
 */
AgentMessageRefusal.prototype['created_at'] = undefined;

/**
 * @member {module:model/AgentMessageRefusalAgent} agent
 */
AgentMessageRefusal.prototype['agent'] = undefined;






export default AgentMessageRefusal;

